export const formatFromPascalCaseToSnakeCase = (variable: string) =>
  variable
    .replace(/(?:^|\.?)([A-Z])/g, (_x, y) => '_' + y.toLowerCase())
    .replace(/^_/, '')
